import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LeadForm() {
  const [form, setForm] = useState({ nome: "", email: "", website: "" });
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await axios.post(`${API}/leads`, form);
      setStatus("done");
      toast.success("Protocollo sbloccato. Il download del diagnostico è partito.");
      const a = document.createElement("a");
      a.href = `${API}/diagnostico`;
      a.download = "NEVER-BETTER_Somatic-Blueprint-Diagnostic-Pack.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (err) {
      setStatus("idle");
      toast.error(
        err.response?.data?.detail || "Errore di invio. Riprova tra poco."
      );
    }
  };

  const inputCls =
    "w-full bg-ink border border-white/10 text-white px-5 py-4 focus:border-neon focus:outline-none transition-colors placeholder:text-[#858599]";

  return (
    <section id="diagnostico" className="relative py-24 sm:py-32 grid-lines">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 50% 60%, rgba(255,85,0,0.07), transparent 60%)",
        }}
      />
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="bg-card border border-white/10 clip-card p-8 sm:p-12">
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-neon">
              Accesso Executive
            </p>
            <h2 className="mt-4 font-display font-bold tracking-tight text-white text-2xl sm:text-3xl lg:text-4xl leading-tight">
              ACCEDI AL DIAGNOSTICO DEI COPIONI SOMATICI &amp; RICEVI IL
              PROTOCOLLO
            </h2>
            {status === "done" ? (
              <div
                data-testid="lead-success-message"
                className="mt-10 border border-emerald-500/40 bg-emerald-500/10 p-6"
              >
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-emerald-400">
                  Protocollo Sbloccato
                </p>
                <p className="mt-3 text-sm text-[#C4C4D0]">
                  Grazie, {form.nome.split(" ")[0]}. Il download del
                  Diagnostico dei Copioni Somatici è partito
                  automaticamente.
                </p>
                <a
                  data-testid="lead-download-button"
                  href={`${API}/diagnostico`}
                  download="NEVER-BETTER_Somatic-Blueprint-Diagnostic-Pack.pdf"
                  className="mt-5 inline-block border border-neon/50 text-neon text-xs font-mono uppercase tracking-[0.25em] px-5 py-3 hover:bg-neon hover:text-black transition-colors"
                >
                  Scarica di nuovo il PDF ↓
                </a>
              </div>
            ) : (
              <form data-testid="lead-form" onSubmit={submit} className="mt-10 space-y-5">
                <input
                  type="text"
                  name="website"
                  value={form.website}
                  onChange={(e) => setForm({ ...form, website: e.target.value })}
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="absolute -left-[9999px] opacity-0 h-0 w-0"
                />
                <div>
                  <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#858599] block mb-2">
                    Nome Completo
                  </label>
                  <input
                    data-testid="lead-input-name"
                    type="text"
                    required
                    minLength={2}
                    placeholder="Marco Rossi"
                    value={form.nome}
                    onChange={(e) => setForm({ ...form, nome: e.target.value })}
                    className={inputCls}
                  />
                </div>
                <div>
                  <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#858599] block mb-2">
                    Email Aziendale / Executive
                  </label>
                  <input
                    data-testid="lead-input-email"
                    type="email"
                    required
                    placeholder="m.rossi@company.com"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    className={inputCls}
                  />
                </div>
                <button
                  data-testid="lead-submit-button"
                  type="submit"
                  disabled={status === "loading"}
                  className="w-full bg-neon text-black font-display font-black text-base sm:text-lg uppercase tracking-wide px-8 py-5 neon-shadow hover:bg-[#ff6a22] transition-colors disabled:opacity-60"
                >
                  {status === "loading"
                    ? "Sblocco in corso…"
                    : "SBLOCCA LO STATO DI FLOW ➔"}
                </button>
                <p className="text-center font-mono text-[10px] uppercase tracking-[0.2em] text-[#858599]">
                  Nessuno spam. Solo il protocollo.
                </p>
              </form>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
